var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBan28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 26c6.627 0 12-5.373 12-12S20.627 2 14 2 2 7.373 2 14s5.373 12 12 12ZM11.052 9.445l2.462 2.134a.742.742 0 0 0 .972 0l2.462-2.134a1.14 1.14 0 0 1 1.607 1.607l-2.134 2.462a.742.742 0 0 0 0 .972l2.134 2.462a1.14 1.14 0 0 1-1.607 1.607l-2.462-2.134a.742.742 0 0 0-.972 0l-2.462 2.134a1.14 1.14 0 0 1-1.607-1.607l2.134-2.462a.742.742 0 0 0 0-.972l-2.134-2.462a1.14 1.14 0 0 1 1.607-1.607Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan28);
export default __webpack_public_path__ + "static/media/ban_28.39340a1c.svg";
export { ForwardRef as ReactComponent };